import React from 'react'
import { string } from 'prop-types'

const Heart = ({ color, ...rest }) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M9.22582 0C8.07688 0 7.00099 0.560718 6.34061 1.42782C5.68052 0.560422 4.60552 0 3.45658 0C1.55114 0 0 1.55114 0 3.45628C0 4.20598 0.236294 4.91989 0.682858 5.51905C0.68966 5.52881 0.697349 5.53827 0.704742 5.54744L5.842 11.6207C5.94994 11.7485 6.10757 11.8227 6.27525 11.8236C6.27644 11.8236 6.27703 11.8236 6.2788 11.8236C6.44412 11.8236 6.60234 11.7523 6.71087 11.6266L11.8771 5.67343C12.3964 5.05297 12.6824 4.26542 12.6824 3.45658C12.6824 1.55114 11.1313 0 9.22582 0Z"
      fill={color}
    />
  </svg>
)

Heart.propTypes = {
  color: string
}

export default Heart
